import { Box, Button, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import ComingSoonBanner from "./ComingSoonBanner";
import ComingSoonFeatures, { type ComingSoonFeature } from "./ComingSoonFeatures";

export type { ComingSoonFeature };

interface ComingSoonModalProps {
  open: boolean;
  onClose: () => void;
  // Banner props
  bannerTitle: string;
  bannerTag1: string;
  bannerTag2: string;
  bannerGradient?: string;
  bannerIconSrc?: string;
  bannerGlowColor?: string;
  // Features props
  subtitle: string;
  features: ComingSoonFeature[];
  // Body
  children: ReactNode;
}

export default function ComingSoonModal({
  open,
  onClose,
  bannerTitle,
  bannerTag1,
  bannerTag2,
  bannerGradient,
  bannerIconSrc,
  bannerGlowColor,
  subtitle,
  features,
  children,
}: ComingSoonModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        "& > .MuiBox-root": {
          width: 396,
          maxWidth: "min(calc(100vw - 30px), 396px)",
          p: 0,
          py: 0,
          borderRadius: "8px",
          border: "1.5px solid #E1E1E2",
          overflow: "hidden",
        },
      }}
    >
      <Box>
        <ComingSoonBanner title={bannerTitle} tag1={bannerTag1} tag2={bannerTag2} gradient={bannerGradient} iconSrc={bannerIconSrc} glowColor={bannerGlowColor} />

        {children}

        <ComingSoonFeatures subtitle={subtitle} features={features} />

        <Stack px={2} mt={2.5} mb={2} alignItems="center" gap={1}>
          <Button fullWidth variant="contained" sx={{ bgcolor: "#3F5EFB", borderRadius: "6px", height: 50, textTransform: "none", fontSize: 16, fontWeight: 500, "&:hover": { bgcolor: "#3350e0" } }}>
            {t("comingSoon.cta", "Être informé en priorité")}
          </Button>
          <Typography onClick={onClose} fontSize={16} fontWeight={500} color="#202020" sx={{ cursor: "pointer", py: 0.5 }}>
            {t("common.close", "Fermer")}
          </Typography>
        </Stack>
      </Box>
    </Modal>
  );
}
